var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { KeychainKeyTypes, KeychainKeyTypesLC, } from '@interfaces/keychain.interface';
import { addCaptionToLoading } from '@popup/multichain/actions/loading.actions';
import { setErrorMessage, setSuccessMessage, } from '@popup/multichain/actions/message.actions';
import { closeModal, openModal } from '@popup/multichain/actions/modal.actions';
import { MultisigUtils } from '@popup/steem/utils/multisig.utils';
import ProposalUtils from '@popup/steem/utils/proposal.utils';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ButtonComponent, { ButtonType, } from 'src/common-ui/button/button.component';
import { OperationButtonComponent } from 'src/common-ui/button/operation-button.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { MetadataPopup } from 'src/common-ui/metadata-popup/metadata-popup.component';
import { PopupContainer } from 'src/common-ui/popup-container/popup-container.component';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
import Config from 'src/config';
import FormatUtils from 'src/utils/format.utils';
import LocalStorageUtils from 'src/utils/localStorage.utils';
const ProposalVotingSection = ({ activeAccount, isMessageContainerDisplayed, globalProperties, setSuccessMessage, setErrorMessage, addCaptionToLoading, openModal, closeModal, }) => {
    const [hasVoted, sethasVoted] = useState(true);
    const [forceClosed, setForcedClosed] = useState(false);
    useEffect(() => {
        if (activeAccount.name) {
            // TODO
            // initHasVotedForProposal();
        }
    }, [activeAccount]);
    const initHasVotedForProposal = () => __awaiter(void 0, void 0, void 0, function* () {
        if (yield ProposalUtils.isRequestingProposalVotes(globalProperties.globals)) {
            let localSkipped = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.PROPOSAL_SKIPPED);
            localSkipped =
                localSkipped &&
                    localSkipped[activeAccount.name] &&
                    localSkipped[activeAccount.name].includes(Config.KEYCHAIN_PROPOSAL);
            // Consider as already voted if it is, or if the account has a proxy or few SP
            const hasVoted = (yield ProposalUtils.hasVotedForProposal(activeAccount.name)) ||
                !!activeAccount.account.proxy.length ||
                FormatUtils.toSP(activeAccount.account.vesting_shares.toString(), globalProperties.globals) < 100 ||
                localSkipped;
            sethasVoted(hasVoted);
        }
    });
    const handleVoteForProposalClicked = () => __awaiter(void 0, void 0, void 0, function* () {
        const twoFaAccounts = yield MultisigUtils.get2FAAccounts(activeAccount.account, KeychainKeyTypes.active);
        let initialMetadata = {};
        for (const account of twoFaAccounts) {
            if (!initialMetadata.twoFACodes)
                initialMetadata.twoFACodes = {};
            initialMetadata.twoFACodes[account] = '';
        }
        if (twoFaAccounts.length > 0) {
            openModal({
                title: 'popup_html_transaction_metadata',
                children: (React.createElement(MetadataPopup, { initialMetadata: initialMetadata, onSubmit: (metadata) => {
                        addCaptionToLoading('multisig_transmitting_to_2fa');
                        processVote({ metaData: metadata });
                        closeModal();
                    }, onCancel: () => closeModal() })),
            });
        }
        else {
            processVote();
        }
    });
    const processVote = (options) => __awaiter(void 0, void 0, void 0, function* () {
        const success = yield ProposalUtils.voteForKeychainProposal(activeAccount.name, activeAccount.keys.active, options);
        if (success) {
            if (success.isUsingMultisig) {
                setSuccessMessage('multisig_transaction_sent_to_signers');
            }
            else
                setSuccessMessage('popup_html_kc_proposal_vote_successful');
        }
        else {
            setErrorMessage('popup_html_proposal_vote_fail');
        }
        setForcedClosed(true);
    });
    const handleReadClicked = () => {
        chrome.tabs.create({
            url: `https://steempro.com/me/proposals/${Config.KEYCHAIN_PROPOSAL}`,
        });
    };
    const handleClose = (event) => __awaiter(void 0, void 0, void 0, function* () {
        event.nativeEvent.stopImmediatePropagation();
        setForcedClosed(true);
        let localSkipped = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.PROPOSAL_SKIPPED);
        if (!localSkipped) {
            localSkipped = {};
        }
        if (!localSkipped[activeAccount.name]) {
            localSkipped[activeAccount.name] = [];
        }
        yield LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.PROPOSAL_SKIPPED, Object.assign(Object.assign({}, localSkipped), { [activeAccount.name]: [
                ...localSkipped[activeAccount.name],
                Config.KEYCHAIN_PROPOSAL,
            ] }));
    });
    if (forceClosed || hasVoted)
        return null;
    return (React.createElement(PopupContainer, { className: "proposal-voting-section" },
        React.createElement("div", { className: "popup-title" },
            React.createElement(SVGIcon, { icon: SVGIcons.TOP_BAR_CLOSE_BTN, onClick: handleClose }),
            getMessage('popup_html_proposal_vote')),
        React.createElement("div", { className: "caption" }, getMessage('popup_html_proposal_request')),
        React.createElement("div", { className: "popup-footer" },
            React.createElement(ButtonComponent, { type: ButtonType.ALTERNATIVE, dataTestId: "button-read-proposal", onClick: handleReadClicked, label: 'html_popup_read', height: "small" }),
            React.createElement(OperationButtonComponent, { dataTestId: "vote-key-chain-proposal", requiredKey: KeychainKeyTypesLC.active, onClick: handleVoteForProposalClicked, label: 'html_popup_vote', height: "small" }))));
};
const mapStateToProps = (state) => {
    return {
        activeAccount: state.steem.activeAccount,
        isMessageContainerDisplayed: state.message.key.length > 0,
        globalProperties: state.steem.globalProperties,
    };
};
const connector = connect(mapStateToProps, {
    setSuccessMessage,
    setErrorMessage,
    addCaptionToLoading,
    openModal,
    closeModal,
});
export const ProposalVotingSectionComponent = connector(ProposalVotingSection);
